import { defineComponent } from 'vue';
import NoUserImg from '../img/no_user.png';
import app from '@/widget/app';
import utils from '@utils/index';
export default defineComponent({
    name: 'NoUser',
    setup() {
        const image = NoUserImg;
        const login = () => {
            if (utils.isApp()) {
                app.postMessage({
                    type: 'userLogin'
                });
            }
            else {
                utils.userLogin();
            }
        };
        return {
            image,
            login
        };
    }
});
